import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MedicareAdvantagePage from './pages/1003';
import MedicareSupplementPage from './pages/MedicareSupplementPage';
import MultiButtonPageWrapper from './pages/1002';
import MultiButtonPageWrapper2 from './pages/1004';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/1001" element={<HomePage />} />
            <Route path="/1003" element={<MedicareAdvantagePage />} />
            <Route path="/medicare-supplement" element={<MedicareSupplementPage />} />
            <Route path="/1002" element={<MultiButtonPageWrapper />} />
            <Route path="/1004" element={<MultiButtonPageWrapper2 />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
